// extracted by mini-css-extract-plugin
export default {"rating":"nC-z","numberOfStars":"oC-z","count":"pC-z","barGraphSpacing":"qC-z","barGraph":"rC-z"};